import React from 'react';
import { SimpleGrid, Button, Icon } from '@chakra-ui/react';
import {
	FaBullhorn,
	FaAddressBook,
	FaFileInvoiceDollar,
	FaProjectDiagram,
	FaUserPlus,
	FaTasks,
} from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { SectionCard } from './dashboardShared';

const ACTIONS = [
	{
		label: 'New campaign',
		icon: FaBullhorn,
		colorScheme: 'teal',
		path: '/campaigns/create',
	},
	{
		label: 'Import contacts',
		icon: FaAddressBook,
		colorScheme: 'green',
		path: '/contacts/import/upload',
	},
	{
		label: 'Create invoice',
		icon: FaFileInvoiceDollar,
		colorScheme: 'purple',
		path: '/invoices/create',
	},
	{
		label: 'New project',
		icon: FaProjectDiagram,
		colorScheme: 'orange',
		path: '/projects/add',
	},
	{
		label: 'Add lead',
		icon: FaUserPlus,
		colorScheme: 'pink',
		path: '/leads',
	},
	{
		label: 'My tasks',
		icon: FaTasks,
		colorScheme: 'blue',
		path: '/todos-and-tasks',
	},
];

const QuickActions = () => {
	const navigate = useNavigate();

	return (
		<SectionCard
			title='Quick actions'
			description='Jump straight into the work you do most often.'>
			<SimpleGrid columns={{ base: 1, sm: 2, lg: 3 }} spacing={3}>
				{ACTIONS.map((action) => (
					<Button
						key={action.label}
						leftIcon={<Icon as={action.icon} />}
						colorScheme={action.colorScheme}
						variant='outline'
						justifyContent='flex-start'
						h='auto'
						py={4}
						onClick={() => navigate(action.path)}>
						{action.label}
					</Button>
				))}
			</SimpleGrid>
		</SectionCard>
	);
};

export default QuickActions;
